import React from 'react';

export interface ItemProps {
  id: string,
  checked: boolean,
  label: string
  tooltip?: string,
  onSelect: Function,
}

const Item = ({
  id,
  label,
  checked,
  onSelect,
  tooltip,
} : ItemProps) => (
  <div className="switcher-item">
    <input
      id={id}
      onChange={(e) => {
        if (e.target.checked) {
          onSelect();
        }
      }}
      type="checkbox"
      defaultChecked={checked}
    />
    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
    <label htmlFor={id} dangerouslySetInnerHTML={{ __html: label }} />
    {(tooltip && <span className="info js-enhanced" title={tooltip} />)}
  </div>
);

export default Item;
